// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"733f28f0","526":"92b487a8","611":"91cefd2a","924":"99d601b6","963":"7e7e10f9"}[chunkId] + ".chunk.js";
};